import { atom } from "recoil";

export const infoSnackbarState = atom({
  key: "infoSnackbarState",
  default: {},
});
